import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LoadingSpinner } from './LoadingSpinner';

export function RootRedirect() {
  const { session, loading, needsOnboarding, isSupportUser, isAdmin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (session) {
        if (isSupportUser) {
          navigate('/support', { replace: true });
        } else if (isAdmin) {
          navigate('/admin/dashboard', { replace: true });
        } else if (needsOnboarding) {
          navigate('/onboarding', { replace: true });
        } else {
          navigate('/dashboard', { replace: true });
        }
      } else {
        navigate('/login', { replace: true });
      }
    }
  }, [session, loading, needsOnboarding, isSupportUser, isAdmin, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <LoadingSpinner />
    </div>
  );
}
